"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_SOLUTION_URL = 'https://www.euclidea.xyz/api/v1/game/solutions';
exports.SEND_BEST_SOLUTION_URL = 'https://www.euclidea.xyz/api/v1/sync/savedsolutions';



//////////////////
// WEBPACK FOOTER
// ./src/config.ts
// module id = 253
// module chunks = 0